import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import '../scss/FrameComponent.scss';

function renderLeftElement(leftElement, orientation) {
    if (leftElement) {
        const leftClassName = classNames(((orientation === 'horizontal') ? 'horizontalContainer__left' : 'verticalContainer__top'), leftElement.props.className);
        return React.cloneElement(leftElement, { className: leftClassName });
    }
    return null;
}

function renderMiddleElement(middleElement) {
    if (middleElement) {
        const middleClassName = middleElement.props.className;
        return React.cloneElement(middleElement, { className: middleClassName });
    }
    return null;
}

function renderRightElement(rightElement, orientation) {
    if (rightElement) {
        const rightClassName = classNames(((orientation === 'horizontal') ? 'horizontalContainer__right' : 'verticalContainer__bottom'), rightElement.props.className);
        return React.cloneElement(rightElement, { className: rightClassName });
    }
    return null;
}


const FrameComponent = ({
    orientation,
    leftElement,
    middleElement,
    rightElement,
    className,
    ...otherProps
}) => (
    <div
        className={classNames(`${orientation}Container`, className)}
        {...otherProps}>
        {renderLeftElement(leftElement, orientation)}
        {renderMiddleElement(middleElement)}
        {renderRightElement(rightElement, orientation)}
    </div>

);

FrameComponent.propTypes = {
    /**
     * Type of FrameComponent
     */
    orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,

    /**
     * Frame Component's left/top element
     */
    leftElement: PropTypes.element,

    /**
     * Frame Component's middle element
     */
    middleElement: PropTypes.element,

    /**
     * Frame Component's right/bottom element
     */
    rightElement: PropTypes.element,
};

FrameComponent.defaultProps = {
    leftElement: null,
    middleElement: null,
    rightElement: null,
};

export default FrameComponent;
